import { TAG_SELECTOR_FEATURE_PROPERTY } from '@/constants/tagSelector';
import type { AppUserInfo } from '@/models/AppViewModel';

function isEnabledFeatureValue(value: string | boolean | undefined): boolean {
  if (typeof value === 'boolean') {
    return value;
  }
  return value?.trim().toLowerCase() === 'true';
}

/**
 * True when the API says the authenticated user can use account tags for their advisor group.
 */
export function userHasTagSelectorAccess(
  userInfo: AppUserInfo | undefined,
): boolean {
  if (!userInfo) {
    return false;
  }

  return (
    isEnabledFeatureValue(
      userInfo.Properties?.[TAG_SELECTOR_FEATURE_PROPERTY],
    ) ||
    (userInfo.AGSettings?.some(
      (setting) =>
        setting.Key === TAG_SELECTOR_FEATURE_PROPERTY &&
        isEnabledFeatureValue(setting.Value),
    ) ??
      false)
  );
}
